import ERROR_MESSAGE from 'consts/error-message';
import UserRole from 'consts/roles';
import { STATUS_FEEDBACK } from 'consts/status-review';
import { StatusModel } from 'consts/topicModels';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import moment from 'moment';

export const getErrorMessage = (response: any) => {
  if (isString(response)) return response;
  const errorMessageResponse = get(response, 'data.type', null);
  const message =
    errorMessageResponse && ERROR_MESSAGE?.[errorMessageResponse]
      ? ERROR_MESSAGE?.[errorMessageResponse]
      : ERROR_MESSAGE.UNHANDLED_EXCEPTION;
  return message;
};

export const convertBreakToHtml = (text: string) => text && text.replace(/\r?\n/g, '<br/>');

export const getDeepCopy = (data: any) => JSON.parse(JSON.stringify(data));

export const NewGuid = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

export function paginate(array: any, pageSize: number, pageIndex: number) {
  return array.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);
}

export function filterList(data: Array<any>, objectFilter: any) {
  if (isEmpty(objectFilter)) return data;
  return data.filter((item: any) => {
    let isExist = 0;
    let totalFilter = 0;
    for (const key in objectFilter) {
      if (item[key] && item[key].toLowerCase().includes(objectFilter[key].toLowerCase())) {
        isExist += 1;
      }
      if (objectFilter[key] || objectFilter[key] === 0 || objectFilter[key] === '') {
        totalFilter += 1;
      }
    }
    if (isExist !== totalFilter) {
      isExist = 0;
    }
    return isExist;
  });
}

export function filterColumnList(
  data: Array<Record<string, any>>,
  column: string | undefined,
  objectFilter: Array<string> | undefined
) {
  if (isEmpty(objectFilter) || isEmpty(column)) return data;
  return data.filter((item: any) => {
    let included = false;
    objectFilter?.forEach((option) => {
      if (option === item[column as string]) {
        included = true;
      }
    });
    return included;
  });
}

interface AnyObject {
  [key: string]: any;
}

export const transformCapitalizeWord = (word: string | undefined | null): string | undefined => {
  if (!word) return undefined;
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export function sortArrayOfObjects(
  arr: AnyObject[],
  propName: string | undefined,
  sortDirection: 'asc' | 'desc' | undefined = 'asc'
): AnyObject[] {
  if (!propName) return arr;
  return arr.sort((a, b) => {
    const propA = a[propName];
    const propB = b[propName];

    if (sortDirection === 'asc') {
      if (propA < propB) return -1;
      if (propA > propB) return 1;
    } else if (sortDirection === 'desc') {
      if (propA > propB) return -1;
      if (propA < propB) return 1;
    }

    return 0;
  });
}

export const convertSearchObject = (obj: Record<string, any> | undefined): Record<string, string> | undefined => {
  if (!obj) return undefined;
  const result: Record<string, string> = {};
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      result[key] = obj[key] as string;
    } else if (typeof obj[key] === 'object') {
      result[key] = (obj[key] as any).value as string;
    }
  }
  return result;
};

export function getRandomDecimal(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

export function validateEmail(email: string | undefined) {
  if (!email) return false;
  return email.includes('@buildcorp.com.au') || email.includes('@euroline.com.au');
}

export const getUserRole = (roles: any) => {
  if (isArray(roles) && roles.length > 0) {
    let result: UserRole | null = UserRole.User;
    roles.forEach((role) => {
      if (!result) {
        switch (role?.name) {
          case UserRole.AdminCompany:
            result = UserRole.AdminCompany;
            break;

          case UserRole.AdminPortal:
            result = UserRole.AdminPortal;
            break;

          case UserRole.User:
            result = UserRole.User;
            break;

          default:
            result = UserRole.User;
            break;
        }
      }
    });
  }
  return UserRole.AdminCompany;
};

export const formatText = (text: string) => {
  if (text) {
    return text.charAt(0).toUpperCase() + text.slice(1, text.length);
  }
  return '';
};
export const formatContent = (text: string) => {
  if (text) {
    return text.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, '');
  }
  return '';
};

export const formatContentFromHtmlString = (text: string) => {
  if (text) {
    const startFragmentExists = /<!-- StartFragment -->/.test(text);
    const endFragmentExists = /<!-- EndFragment -->/.test(text);
    if (startFragmentExists && endFragmentExists) {
      const regex = /<!-- StartFragment -->([\s\S]*?)<!-- EndFragment -->/;
      const match = text.match(regex);
      const extractedContent = match ? match[1] : '';
      const textWithoutTags = extractedContent.replace(/<[^>]+>/g, '').replace(/·&nbsp;/g, '');
      return textWithoutTags;
    }
    const divElement = document.createElement('div');
    divElement.innerHTML = text;
    const chilNodes = divElement.childNodes;
    const textContent = divElement.innerText;
    chilNodes.forEach((element) => {
      if (element instanceof HTMLElement) {
        element.insertAdjacentHTML('afterend', '&nbsp;');
      }
    });
    const formattedText = divElement.textContent?.replace(/\s+/g, ' ').trim();
    return formattedText;
  }
  return '';
  // if (text) {
  //   const divElement = document.createElement('div');
  //   divElement.innerHTML = text;
  //   const textContent = divElement.innerText;
  //   const formattedText = textContent.replace(/([a-z])([A-Z])/g, '$1 $2');
  //   return formattedText;
  // }
  // return '';
};

export const convertArrayParams = (params: any) => {
  const keys = Object.keys(params);
  const result = keys.reduce((total, key) => {
    if (Array.isArray(params[key])) {
      params[key].forEach((val: any) => {
        if (!val) return;
        total += total ? `&${key}=${val}` : `${key}=${val}`;
      });
    } else {
      total += total ? (params[key] ? `&${key}=${params[key]}` : '') : params[key] ? `${key}=${params[key]}` : '';
    }
    return total;
  }, '');

  return result;
};

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function formatNumberToString(num: number | null) {
  if (num === null) {
    return 0;
  }
  return num < 10 ? `0${num}` : `${num}`;
}
export const getImageLink = (FilePath: string): string => process.env.REACT_APP_IMG_URL + FilePath;

export const formatDate = (date: string) => {
  if (date) {
    return moment(new Date(date).toISOString().split('T')[0]).format('DD/MM/YYYY');
  }
  return '';
};

export const convertSunEditorGet = (initialHTML: any) => {
  return (
    initialHTML
      ?.replace(/<div\s+class="d-inline"([^>]*)\s+style="([^"]*)"\s*>([^]*?)<\/div>/g, '<span$1 style="$2">$3</span>')
      ?.replace(
        /<div\s+class="d-inline"([^>]*)\s+style="([^"]*)"\s+"?"([^>]*)>([\s\S]*?)<\/div>/g,
        '<span$1 style="$2"$3>$4</span>'
      ) || ''
  );
};

export const convertSunEditorSubmit = (initialHTML: any) => {
  const text = initialHTML.replaceAll(/<p\s*>\s*<\/p\s*>/g, '');
  // const text = initialHTML
  //           .replaceAll('', '<div class="d-inline" $1> ')
  //           .replaceAll(/<\/span>/g, "</div>");
  return text || '';
};

export const convertDisplayName = (info: any) => {
  const result =
    info?.reduce((o: string, c: any) => {
      if (!o) {
        return c.displayName || '';
      }
      return `${o}, ${c.displayName || ''}`;
    }, '') || '';
  return result;
};

export const convertDisplayNameVersion = (info: any) => {
  const result =
    info?.reduce((o: string, c: any) => {
      if (!o) {
        return c.name || '';
      }
      return `${o}, ${c.name || ''}`;
    }, '') || '';
  return result;
};

export const largestNumber = (arr: string[]) => {
  const result = arr.reduce(
    (acc: number, currentValue: string) => (acc > Number(currentValue) ? acc : Number(currentValue)),
    0
  );
  return result;
};

export const getValueFilterView = (arr: string[]) => {
  if (arr[0] === 'WithViews') {
    return true;
  }
  if (arr[0] === 'NoViews') {
    return false;
  }
  return null;
};


export const checkTypeUrl= () => {
    sessionStorage.setItem("typeUrl", 'true');
}

export const convertToPx = (value: string | number, contextElement: HTMLElement = document.body) => {
  if (typeof value === 'number') {
      return value;
  }

  const units: { [key: string]: number } = {
      'px': 1,
      'rem': parseFloat(getComputedStyle(document.documentElement).fontSize),
      'em': parseFloat(getComputedStyle(contextElement).fontSize),
      '%': parseFloat(getComputedStyle(contextElement).width) / 100
  };

  const unit = value.match(/[a-z%]+$/i);
  const number = parseFloat(value);

  if (unit && units[unit[0]]) {
      return number * units[unit[0]];
  } 
  return number;
}

export const getLabelStatusFeedBack = (value: number | null) => {
  if (value === null) {
    return null;
  }
  
  return STATUS_FEEDBACK.find((item: any) => item.value === value) || null
};

export const isAdvancedSearch = () => {
  return window.location.pathname.includes('/advanced-search');
};